// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__14Fne","booksContainer":"Hero_booksContainer__cclbB","text":"Hero_text__HmkbC","tagline":"Hero_tagline__3Rhee"};